import axiosInstance from '../../../helpers/backend_helper';


const createOneShotEpisode = async ({content, audio, video, duration, story_id}) => {
  try {
    const formData = new FormData();
    formData.append('content', content);
    audio && formData.append('audio', audio);
    video && formData.append('video', video);
    formData.append("duration", duration);
    formData.append("story_id", story_id);

    const response = await axiosInstance.post(`episodes/one-shot`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data.data;
  } catch (error) {
    console.error('Error creating episode:', error);
    throw error;
  }
};

export default createOneShotEpisode;
